// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import { auth } from '@/firebase'
import { defineCustomElements } from '@ionic/pwa-elements/loader'
import './registerServiceWorker'

Vue.config.productionTip = false

auth.onAuthStateChanged(user => {
  if (user) {
    store.dispatch('fetchUserProfile', user) // fonction à rajouter plus tard dans store
  }
})

/* eslint-disable no-new */
let app // modifier l'app
auth.onAuthStateChanged(user => {
  if (!app) {
    new Vue({
      el: '#app',
      mode: 'history',
      store: store,
      router,
      vuetify,
      components: { App },
      template: '<App/>'
    })
  }

  if (user) {
    store.dispatch('fetchUserProfile', user) // fonction à rajouter plus tard dans store
  }
})

defineCustomElements(window)



// WEBPACK FOOTER //
// ./src/main.js